// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';
import Link from '@deere/cps-it.warranty-model-factory/lib/link';
import {getLinks} from '../../../shared/services/get-links';

const UsefulLinksPanel = props =>
    <div className='useful-links-panel'>
        <header>
            <FormattedMessage id='USEFUL_LINKS'/>
        </header>
        <div className='links'>
            <ul className='link-list'>
                {getLinks(props.links, 'TCSM').map((link, index) =>
                    <li key={index}>
                        <a
                            href={link.url}
                            rel='noopener noreferrer'
                            target='_blank'
                        >
                            {link.label}
                        </a>
                    </li>
                )}
            </ul>
        </div>
    </div>;

UsefulLinksPanel.displayName = 'UsefulLinksPanel';
UsefulLinksPanel.propTypes = {
    links: PropTypes.arrayOf(PropTypes.instanceOf(Link)).isRequired
};

export default UsefulLinksPanel;



// WEBPACK FOOTER //
// ./src/tcsm/wip/components/useful-links-panel.js